import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// components
import { LoadingScreen } from '@/components/feedback/loading-screen';

// ----------------------------------------------------------------------

const ForecastPage = lazy(() => import('@pages/management/reports/forecast'));

const SubscriptionsPage = lazy(() => import('@pages/management/reports/subscriptions'));

const SalesReportPage = lazy(() => import('@pages/management/reports/sales'));

// ----------------------------------------------------------------------

export const reportsRoutes = [
  {
    path: 'reports',
    children: [
      {
        path: 'forecast',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <ForecastPage />
          </Suspense>
        ),
      },
      {
        path: 'subscriptions',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <SubscriptionsPage />
          </Suspense>
        ),
      },
      {
        path: 'sales',
        element: (
          <Suspense fallback={<LoadingScreen />}>
            <SalesReportPage />
          </Suspense>
        ),
      },
    ],
  },
];
